import IconLock from './IconLock';
import IconChevron from './IconChevron';
import IconClose from './IconClose';
import IconDownTriangle from './IconDownTriangle';
import IconChevronUp from './IconChevronUp';
import IconPDF from './IconPDF';
import Logo from './Logo';

export {
	IconLock,
	IconClose,
	IconChevron,
	IconDownTriangle,
	IconChevronUp,
	IconPDF,
	Logo,
};
